/* KX Graphics customization form - shared behaviour (validation, previews, duplicate-submit guard). */
(function () {
  if (window.KxDecalForm) return;
  window.KxDecalForm = true;

  var MAX_BYTES = 10 * 1024 * 1024;
  var TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  var EXT = /\.(jpe?g|png|webp|gif)$/i;

  var MSG = {
    description: 'Please describe your custom design before adding this to your cart.',
    missing: 'Please upload a reference image before adding this to your cart.',
    type: 'That file type is not supported. Please choose a JPG, PNG or WEBP image.',
    size: 'That image is larger than 10 MB. Please choose a smaller image.',
    empty: 'That file looks empty. Please choose a different image.',
    summary: 'Please fix the highlighted fields to add this to your cart.',
    added: 'Added to your cart with your design details and images.'
  };

  function fileProblem(file) {
    if (!file) return null;
    var type = (file.type || '').toLowerCase();
    var typeOk = TYPES.indexOf(type) > -1 || (!type && EXT.test(file.name || ''));
    if (!typeOk) return 'type';
    if (file.size === 0) return 'empty';
    if (file.size > MAX_BYTES) return 'size';
    return null;
  }

  function formatSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  function Kx(root) {
    var self = this;
    this.root = root;
    this.formId = root.getAttribute('data-form-id');
    this.sectionId = root.getAttribute('data-section-id');
    this.busy = false;
    this.busyTimer = null;
    this.submittedVariant = null;
    this.summary = root.querySelector('[data-kx-summary]');
    this.success = root.querySelector('[data-kx-success]');

    this.desc = root.querySelector('[data-kx-desc]');
    this.uploads = [];
    root.querySelectorAll('[data-kx-upload]').forEach(function (box) {
      var u = {
        box: box,
        input: box.querySelector('input[type="file"]'),
        required: box.getAttribute('data-required') === 'true',
        err: box.parentNode.querySelector('[data-kx-error]'),
        label: box.querySelector('[data-kx-upload-text]'),
        sel: box.querySelector('[data-kx-selected]'),
        thumb: box.querySelector('[data-kx-thumb]'),
        nameEl: box.querySelector('[data-kx-filename]'),
        sizeEl: box.querySelector('[data-kx-filesize]'),
        remove: box.querySelector('[data-kx-remove]'),
        url: null
      };
      u.defaultLabel = u.label ? u.label.textContent : '';
      u.input.addEventListener('change', function () {
        self.hideSuccess();
        self.showFile(u);
        self.checkUpload(u, false);
      });
      if (u.remove) {
        u.remove.addEventListener('click', function () {
          u.input.value = '';
          self.showFile(u);
          self.clearError(u.input, u.err);
          u.input.focus();
        });
      }
      ['dragenter', 'dragover'].forEach(function (ev) {
        box.addEventListener(ev, function () { box.classList.add('is-drag'); });
      });
      ['dragleave', 'drop', 'dragend'].forEach(function (ev) {
        box.addEventListener(ev, function () { box.classList.remove('is-drag'); });
      });
      self.uploads.push(u);
    });

    this.descErr = this.desc ? this.desc.parentNode.querySelector('[data-kx-error]') : null;
    if (this.desc) {
      this.desc.addEventListener('input', function () {
        self.hideSuccess();
        if (self.desc.value.trim()) self.clearError(self.desc, self.descErr);
      });
      this.desc.addEventListener('blur', function () { self.checkDesc(); });
    }

    document.addEventListener('submit', function (evt) { self.onSubmit(evt); }, true);

    /* Reset after a successful add so the same design is never submitted twice by accident. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (!self.busy) return;
        if (data && data.productVariantId && self.submittedVariant && String(data.productVariantId) !== String(self.submittedVariant)) return;
        self.done();
        self.reset();
        self.showSuccess();
      });
      subscribe(PUB_SUB_EVENTS.cartError, function (data) {
        if (!self.busy) return;
        if (data && data.productVariantId && self.submittedVariant && String(data.productVariantId) !== String(self.submittedVariant)) return;
        self.done();
      });
    }

    /* Defence in depth: accelerated checkout buttons would skip the required fields. */
    var scope = root.closest('section') || document.body;
    scope.classList.add('kx-decal-product');
    scope.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (b) {
      b.style.display = 'none';
    });
  }

  Kx.prototype.setError = function (field, errEl, message) {
    if (field) field.setAttribute('aria-invalid', 'true');
    if (errEl) { errEl.textContent = message; errEl.hidden = false; }
    if (field && field.closest) {
      var wrap = field.closest('.kx-field');
      if (wrap) wrap.classList.add('has-error');
    }
  };

  Kx.prototype.clearError = function (field, errEl) {
    if (field) field.removeAttribute('aria-invalid');
    if (errEl) errEl.hidden = true;
    if (field && field.closest) {
      var wrap = field.closest('.kx-field');
      if (wrap) wrap.classList.remove('has-error');
    }
    if (this.summary && !this.root.querySelector('.has-error')) this.summary.hidden = true;
  };

  Kx.prototype.checkDesc = function () {
    if (!this.desc) return true;
    if (!this.desc.value.trim()) { this.setError(this.desc, this.descErr, MSG.description); return false; }
    this.clearError(this.desc, this.descErr);
    return true;
  };

  Kx.prototype.checkUpload = function (u, enforceRequired) {
    var file = u.input.files && u.input.files[0];
    if (!file) {
      if (u.required && enforceRequired) { this.setError(u.input, u.err, MSG.missing); return false; }
      this.clearError(u.input, u.err);
      return true;
    }
    var problem = fileProblem(file);
    if (problem) { this.setError(u.input, u.err, MSG[problem]); return false; }
    this.clearError(u.input, u.err);
    return true;
  };

  Kx.prototype.showFile = function (u) {
    var file = u.input.files && u.input.files[0];
    if (u.url) { URL.revokeObjectURL(u.url); u.url = null; }
    if (!file) {
      if (u.sel) u.sel.hidden = true;
      if (u.thumb) u.thumb.removeAttribute('src');
      if (u.label) u.label.textContent = u.defaultLabel;
      u.box.classList.remove('has-file');
      return;
    }
    u.box.classList.add('has-file');
    if (u.nameEl) u.nameEl.textContent = file.name;
    if (u.sizeEl) u.sizeEl.textContent = formatSize(file.size);
    if (u.thumb && !fileProblem(file)) {
      u.url = URL.createObjectURL(file);
      u.thumb.src = u.url;
      u.thumb.hidden = false;
    } else if (u.thumb) {
      u.thumb.removeAttribute('src');
      u.thumb.hidden = true;
    }
    if (u.sel) u.sel.hidden = false;
    if (u.label) u.label.textContent = 'Tap to choose a different image';
  };

  Kx.prototype.validate = function () {
    var ok = true;
    var first = null;
    if (!this.checkDesc()) { ok = false; first = first || this.desc; }
    for (var i = 0; i < this.uploads.length; i++) {
      if (!this.checkUpload(this.uploads[i], true)) { ok = false; first = first || this.uploads[i].input; }
    }
    if (this.summary) { this.summary.textContent = MSG.summary; this.summary.hidden = ok; }
    return { ok: ok, first: first };
  };

  Kx.prototype.onSubmit = function (evt) {
    var target = evt.target;
    /* getAttribute('id'): the form has a hidden <input name="id">, which shadows form.id. */
    if (!target || typeof target.getAttribute !== 'function' || target.getAttribute('id') !== this.formId) return;

    if (this.busy) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    var result = this.validate();
    if (!result.ok) {
      evt.preventDefault();
      evt.stopPropagation();
      var field = result.first;
      if (field) {
        var wrap = field.closest('.kx-field') || field;
        if (wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (field.focus) field.focus({ preventScroll: true });
      }
      return;
    }

    var idInput = target.querySelector('[name="id"]');
    this.submittedVariant = idInput ? idInput.value : null;
    this.busy = true;
    this.hideSuccess();
    var self = this;
    clearTimeout(this.busyTimer);
    this.busyTimer = setTimeout(function () { self.done(); }, 45000);
  };

  Kx.prototype.done = function () {
    this.busy = false;
    clearTimeout(this.busyTimer);
  };

  Kx.prototype.reset = function () {
    if (this.desc) this.desc.value = '';
    this.root.querySelectorAll('input[type="text"]').forEach(function (i) { i.value = ''; });
    for (var i = 0; i < this.uploads.length; i++) {
      this.uploads[i].input.value = '';
      this.showFile(this.uploads[i]);
      this.clearError(this.uploads[i].input, this.uploads[i].err);
    }
    if (this.desc) this.clearError(this.desc, this.descErr);
  };

  Kx.prototype.showSuccess = function () {
    if (!this.success) return;
    this.success.textContent = MSG.added;
    this.success.hidden = false;
  };

  Kx.prototype.hideSuccess = function () {
    if (this.success) this.success.hidden = true;
  };

  function init() {
    document.querySelectorAll('[data-kx-decal-form]').forEach(function (root) {
      if (root.getAttribute('data-kx-bound') === 'true') return;
      root.setAttribute('data-kx-bound', 'true');
      new Kx(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
